import React from "react";
// import "./Works.css";
import "../Services/Services.css";
import Snap from "./snapweb.ico";
import Face from "./facs.ico";
import Learn from "./lernify.ico";
import Metro from "./delhimetro.ico";
import Visu from "./visul.ico";
import Card from "../Card/Card";
import { themeContext } from "../../Context";
import { useContext } from "react";
import {Link} from 'react-scroll'
function Works() {
  const theme=useContext(themeContext);
  const darkMode=theme.state.darkMode;
  return (
    <div className="services" id="Projects">
      {/* left side */}
      <div className="skills">
        <span style={{color:darkMode?'white':''}} >My</span>
        <span>Projects</span>
        <span style={{color:darkMode?'white':''}} >Frontend Developer</span>

        <div
          className="blur s-blur1"
          style={{
            background: "#ABF1FF94",
          }}
        ></div>
        <br/>
        <Link spy={true} to="Contact" smooth={true} activeClass="'activeClass">
        <button className="i-button button">Hire me</button>
        </Link>
        
      </div>

      {/* right side  */}

      <div className="cards">
        {/* 1st card */}
        <div style={{ left: "35rem", top: "-2rem" }}>
          <Card
            emoji={Snap}
            Heading={"SnapWeb"}
            details={"AI-based Summarizer"}
            lnk={
              "https://64a2b2b0de745176af7bd827--creative-rolypoly-82a233.netlify.app/"
            }
            linktext="Link"
          />
        </div>

        {/* 2nd card  */}
        <div style={{ top: "-2rem", left: "10rem" }}>
          <Card
            emoji={Metro}
            Heading={"Delhi metro route finder"}
            details={"NodeJs,Dijkastra"}
            lnk={"https://lazy-erin-piglet-cape.cyclic.app/"}
            linktext="Link"
          />
          
        </div>

        {/* 3rd card  */}
        <div style={{ top: "19rem", left: "10rem" }}>
          <Card
            emoji={Learn}
            Heading={"Learnify"}
            details={"Students Learning with 3-D model"}
            lnk={
              "https://64aae829c6d6e6480ddcc02b--stupendous-cupcake-1be46a.netlify.app/"
            }
            linktext="Link"
          />
        </div>
        {/* 4rd card  */}
        <div style={{ top: "19rem", left: "35rem" }}>
          <Card
            emoji={Visu}
            Heading={"Sorting Visualizer"}
            details={"Visualize the algorithm"}
            lnk={"https://ranjeet16pd.github.io/sorting_visualizer/"}
            linktext="Link"
          />
        </div>
        <div style={{ top: "12rem", left: "23rem" }}>
          <Card
            emoji={Face}
            Heading={"Face Recognization attendence"}
            details={"Microsoft"}
            lnk={"https://drive.google.com/file/d/141IyCV3-aqswTvvDJK-QJaaY-XpWxgui/view"}
            linktext="Link"
          />
        </div>

        <div
          className="blur s-blur2"
          style={{
            background: "var(--purple)",
          }}
        ></div>
      </div>
    </div>
  );
}

export default Works;
